interface IGetFormattedValueParams {
  decimalSign: string
  locales: string | string[]
  value?: string
  format?: 'decimal' | 'percent'
  useGrouping?: boolean
  hasZero?: boolean
  maximumFractionDigits: number
}

export const getFormattedValue = ({
  value,
  locales,
  format,
  useGrouping,
  decimalSign,
  hasZero,
  maximumFractionDigits,
}: IGetFormattedValueParams) => {
  if (value) {
    const formatter = new Intl.NumberFormat(locales, {
      style: format,
      useGrouping,

      maximumFractionDigits,
    })

    if (value === '-') {
      return '-'
    }

    if (value.endsWith(decimalSign)) {
      return formatter.format(Number(value)) + decimalSign
    }

    if (hasZero) {
      const [firstPart, secondPart] = value.split(decimalSign)

      return formatter.format(Number(firstPart)) + (secondPart ? `${decimalSign}${secondPart}` : '')
    }

    return formatter.format(Number(value))
  }

  return ''
}
